module.exports = __webpack_public_path__ + "static/img/2.0993cb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/sp/2.png
// module id = OKVz
// module chunks = 0